import { Component, Input } from '@angular/core';
import { DiscountCodesSettings, GlobalButtonDesign, GLOBAL_BUTTON_DESIGN_DEFAULT } from '../widget-preview.types';

const SAMPLE_APPLIED_CODE = { code: 'SAVE10' };

interface ResolvedButton {
  backgroundColor: string;
  textColor: string;
  hoverColor: string;
  cornerRadius: number;
}

@Component({
  selector: 'discount-codes-preview',
  templateUrl: './discount-codes-preview.component.html',
  styleUrls: ['./discount-codes-preview.component.scss'],
  standalone: false,
})
export class DiscountCodesPreviewComponent {
  @Input() settings!: DiscountCodesSettings;
  @Input() globalButtonDesign: GlobalButtonDesign = GLOBAL_BUTTON_DESIGN_DEFAULT;

  readonly sample = SAMPLE_APPLIED_CODE;

  get resolved(): ResolvedButton {
    const d = this.settings.design;
    const g = this.globalButtonDesign;
    return {
      backgroundColor: d.backgroundColor ?? g.backgroundColor,
      textColor: d.textColor ?? g.textColor,
      hoverColor: d.hoverColor ?? g.hoverTextColor,
      cornerRadius: d.cornerRadius ?? g.cornerRadius,
    };
  }

  onApplyHoverEnter(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolved.hoverColor;
  }

  onApplyHoverLeave(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolved.backgroundColor;
  }
}
